import { Center, Stack, Text, Button } from '@mantine/core'
import { useNavigate } from 'react-router-dom'

export default function NotFound() {
  const navigate = useNavigate()

  return (
    <Center style={{ minHeight: '100vh' }}>
      <Stack align="center" gap="md">
        <Text size="4rem" fw={700} ff="Orbitron, sans-serif" c="cyan.4">
          404
        </Text>
        <Text c="dimmed" size="lg">
          This sector of space is uncharted.
        </Text>
        <Button onClick={() => navigate('/')}>
          Return to Base
        </Button>
      </Stack>
    </Center>
  )
}
